export default __webpack_public_path__ + "static/media/DescribingPeople_05.5eeda161.png";